// extracted by mini-css-extract-plugin
export default {"title":"BX8nng","name":"hpvv7q","description":"p5brvR","short":"ap8uG2","wrapper":"zMpWGp","link":"Ujboah"};